import * as React from 'react'
import { useRefinementList } from 'react-instantsearch-hooks-web'

type VirtualRefinementListProps = {
  attribute: string
}

const VirtualRefinementList: React.FC<VirtualRefinementListProps> = ({
  attribute,
}) => {
  useRefinementList({ attribute })

  return null
}

export default VirtualRefinementList
